import { ReactFlowProvider } from '@xyflow/react';
import { SelectedEntityProvider } from 'advanced-filters/context';
import { ADVANCED_SEARCH_ENTITY_KEY } from 'automations/data/advancedFilter';

export default function AutomationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SelectedEntityProvider entity={ADVANCED_SEARCH_ENTITY_KEY}>
      <ReactFlowProvider>
        {children}
      </ReactFlowProvider>
    </SelectedEntityProvider>
  );
}
